import angular from 'angular';
import PriceFilterDirective from './price-filter.directive';

let PriceFilterModule = angular.module('catalog.productsList.priceFilter', [])
  .directive('priceFilter', PriceFilterDirective);

export default PriceFilterModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/products-list/price-filter/price-filter.js
 **/